// CTA versions
export const DEFAULT = 'DEFAULT';
export const PROJECT_LOCK_SCREEN = 'PROJECT_LOCK_SCREEN';
